import { defineStore } from 'pinia'
import { isBuyApp, isBuyDevice } from '@/apis/appStore'
import { setCache, getCache } from '@/utils/cache/local'
export const useZzyStore = defineStore('zzy', () => {
  const isBuyZzy = ref(getCache('isBuyZzy'))
  const isBuyMDM = ref(getCache('isBuyMDM'))

  async function setIsBuyZzy() {
    const res = await isBuyApp({
      appCode: '83842bf547c1422fb67ad18d068fd8e3'
    })
    isBuyZzy.value = res
    setCache('isBuyZzy', isBuyZzy.value)
  }

  async function setIsBuyMDM() {
    const res = await isBuyDevice({})
    isBuyMDM.value = res?.total !== 0
    setCache('isBuyMDM', isBuyMDM.value)
  }

  return {
    isBuyZzy,
    isBuyMDM,
    setIsBuyZzy,
    setIsBuyMDM
  }
})
